import React from 'react';
import {Box} from '@mui/material';
import UserMessage from './UserMessage';
import SystemMessage from './SystemMessage';

const MessageList = ({messages = [], lastMessageRef}) => {
    return (
        <>
            {messages.map((message, index) => {
                const role = message?.role || 'user';
                const key = message?.id || `${role}-${index}`;
                const isLast = index === messages.length - 1;
                return (
                    <Box key={key} width={'100%'} ref={isLast ? lastMessageRef : null}>
                        {role === 'system' || role === 'assistant' ? (
                            <SystemMessage message={message}/>
                        ) : (
                            <UserMessage message={message}/>
                        )}
                    </Box>
                );
            })}
        </>
    );
};

export default MessageList;
